<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Liste des utilisateurs du four {{ ovenName }}</span>
      </v-card-title>
      <v-card-text>
        <v-list two-line subheader>
          <v-list-tile v-for="user in userList" v-bind:key="user.id">
            <v-list-tile-content>
              <v-list-tile-title>{{ user.name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon @click.stop="removeUser(user)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-btn color="black" flat large @click="$emit('close'); resetAll()">Fermer</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Dialog de suppression d'utilisateur du four -->
    <v-dialog v-model="removeUserDialog" persistent max-width="600px">
      <OvenUsersRemove @close="removeUserDialog = false;" @reloadUserList="reloadUserList()" ref="removeUser"
        :oven="oven" :user="userSelected"></OvenUsersRemove>
    </v-dialog>
  </div>
</template>



<script>
import OvenUsersRemove from "./OvenUsersRemove";
export default {
  components: {
    OvenUsersRemove
  },
  props: ["oven"],
  data: () => ({
    removeUserDialog: false,
    userList: [],
    userSelected: null
  }),
  computed: {
    ovenName() {
      if (!this.oven) {
        return "no oven";
      }
      return this.oven.name || this.oven.macAddress;
    }
  },
  watch: {
    oven() { }
  },
  methods: {
    resetAll() {
      this.userList = [];
    },
    // chargement des utilisateurs
    loadUserList(ovenId) {
      this.api
        .get("/clients/me/ovens/" + ovenId + "/users")
        .then(res => {
          this.userList = res.data;
        })
        .catch(err => {
          this.$emit("close");
          this.resetAll();
          // console.error(err);
        });
    },
    reloadUserList() {
      if (this.oven) {
        this.loadUserList(this.oven.id);
      }
    },
    removeUser(user) {
      this.userSelected = user;
      this.removeUserDialog = true;
      this.$refs["removeUser"].remove();
    }
  },
  mounted() { }
};
</script>

<style>

</style>


